import { useEffect } from 'react';
import { ALL_ROUTES } from 'config/routes';
import { findAllowedRoute } from 'helpers/checkPermissions';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToRoute } from '../../redux_store';

const Home = () => {
  const dispatch = useDispatch();
  const {
    metadata: { currentAccountPermissions, currentAccount },
  } = useSelector((state) => state.user);
  const { disabledFeatures } = useSelector((state) => state.appSettings);

  useEffect(() => {
    const newRoute = findAllowedRoute(
      ALL_ROUTES.dashboard.root,
      currentAccountPermissions,
      disabledFeatures,
    );
    dispatch(navigateToRoute({ route: {
      replace: true,
      path: newRoute.path,
      title: newRoute.additional.title,
      clearBreadcrumbs: true,
      params: { currentAccountUuid: currentAccount.uuid },
    }}));
  }, []);
  return null;
};

export default Home;
